import { css } from '@emotion/react';

const getActionOverflowWrapperCss = css`
  position: relative;
  display: inline-block;
`;

export default getActionOverflowWrapperCss;
